import { motion } from 'framer-motion';



export default function NameHeader () {

    return (
        <div className='mt-28  w-full' >
            <section className="flex  items-center  justify-space-between px-6 w-full">
                <h1 className="text-3xl font-bold text-persian font-playfair w-[60%]">Juan Bautista Calvo</h1>
                <motion.div 
                    initial={{ scale: 1.5 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.5 }}
                    className="w-[40%] flex justify-center">
                        <motion.img
                        className="w-28 h-28 rounded-full" 
                        alt="JBC Photo" 
                        src="/images/jbc-photo.jpeg"/>
                </motion.div>
            </section>
            <section className='bg-persian h-1 w-1/2 flex mt-2'></section>
        </div>
    )

} 